// URL-encoded link back into the Resource access grants inventory,
// pre-filtered by a single dimension. useListGrants reads these same
// keys from window.location.search.
//
// Pass the current URL search string so existing filters / presets /
// search text are preserved; the chip just overwrites one key.

export type GrantFilterKey =
  | 'trustStatus'
  | 'grantScope'
  | 'grantOrigin'
  | 'mechanism'
  | 'principalType'
  | 'assetType';

const INVENTORY_PATH = '/access-grants';

export function inventoryFilterLink(
  key: GrantFilterKey,
  value: string,
  currentSearch: string = '',
): string {
  const params = new URLSearchParams(currentSearch);
  params.set(key, value);
  const query = params.toString();
  return query ? `${INVENTORY_PATH}?${query}` : INVENTORY_PATH;
}
